var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTekkrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_5401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1572 0.269653L30.8841 9.5555L21.1834 18.8665L11.4565 9.58062L21.1572 0.269653Z",
    fill: "#BA1D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97705 11.2256L19.704 20.5114L10.0033 29.8223L0.276367 20.5365L9.97705 11.2256Z",
    fill: "#BA1D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.269 22.1258L30.9959 31.4118L21.2952 40.7227L11.5684 31.4368L21.269 22.1258Z",
    fill: "#BA1D68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_5401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTekkrIcon);
export default __webpack_public_path__ + "static/media/tekkr-icon.49c796279ee0f82b24b095a3608041fb.svg";
export { ForwardRef as ReactComponent };